const jsonToProps = ({ map_info, content_rows, ...rest }) => ({
  mapInfo: map_info,
  contentRows: content_rows,
  ...rest,
});

export default jsonToProps;
